import CustomerSelector from "@components/global/new/CustomerSelector/CustomerSelector";
import FieldAdminIncome from "@components/global/new/FieldAdminIncome/FieldAdminIncome";
import LocationSelector from "@components/global/new/LocationSelector/LocationSelector";
import MinerTypeSelector from "@components/global/new/MinerTypeSelector/MinerTypeSelector";
import { MINER_SETTINGS_E } from "@services/getMinerList";
import { DeviceI, getDevices } from "@utils/dev_utils";
import { useCallback, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { IAdminSettingsProps } from "./AdminSettings.props";
import { useAdminSettingsControl } from "./useAdminSettingsControl";
import { ContractPlanOnChangeParams, ContractPlanSelect } from "../MinerRow/MinerRowMore/MinerRowMoreSettings/ContractPlanSelector/ContractPlanSelector";
import { dev } from "@utils/dev";
import { UserI } from "@services/getUsers";

export default function AdminSettings({
  minerId,
  mining_persent,
  customer,
  miner_type,
  default_speed,
  miner_plan,
  admin_setting,
  miner_location,
  contractId: contract,
  setSelectedValue,
  ...props
}: IAdminSettingsProps) {

  const { formatMessage } = useIntl();
  const control = useAdminSettingsControl(minerId ?? "");

  const onSubmit: ReturnType<typeof useAdminSettingsControl>["onSubmit"] = (
    value
  ) => {
    if (!props.noSubmit) {
      control.onSubmit(value);
    }
  };

  const onContractPlanChanged = useCallback((params: ContractPlanOnChangeParams) => {
    if (params.contractId !== undefined) {
      control.onSubmit({
        [MINER_SETTINGS_E.MINER_CONTRACT]: String(params.contractId || "-1"),
        [MINER_SETTINGS_E.MINER_PLAN]: "-1"
      });
    } else {
      control.onSubmit({
        [MINER_SETTINGS_E.MINER_PLAN]: String(params.planId || "-1"),
        "prev_plan": String(params.prevPlanId || "-1"),
      });
    }
  }, [control.onSubmit, minerId]);

  const onCustomerChanged = useCallback((user?: UserI) => {
    // если userUuid = "0000-0000", то передается майнер админу (забирается у клиента)
    // и нужно убрать настройки этого пользователя у miner.all_settings
    if (user?.Uuid === "0000-0000" && customer?.id) {
      control.removeUserSettings(parseInt(customer.id));
    }
    onSubmit(
      { [MINER_SETTINGS_E.USER_CODE]: String(user?.Uuid || "") },
      user
    );
    props.setCustomer?.(user);
  }, [onSubmit, props.setCustomer]);

  return (
    <>
      <CustomerSelector
        hasCleanUp={false}
        id={MINER_SETTINGS_E.USER_CODE}
        customer={customer}
        isOwnMining={props.isOwnMining}
        name={formatMessage({ id: "machines.settings.customer" })}
        onChange={onCustomerChanged}
        addSelf={true}
        customerType="except_t"
        onCleanUp={props.setCustomer}
      />
      <MinerTypeSelector
        name={formatMessage({ id: "machines.settings.type" })}
        id={MINER_SETTINGS_E.MINER_PROFILE}
        getValue={(v) => {
          onSubmit({ [MINER_SETTINGS_E.MINER_PROFILE]: String(v?.id || "") });
          //onChangeMinerType(v?.name || "");
        }}
        value={miner_type}
      />
      <LocationSelector
        hasCleanUp
        showPrev
        name={formatMessage({ id: "machines.settings.location" })}
        id={MINER_SETTINGS_E.MINER_LOCATION}
        location={miner_location}
        onGetValue={(location) => {
          onSubmit({
            [MINER_SETTINGS_E.MINER_LOCATION]: String(location?.id || ""),
          });
        }}
      />
      <FieldAdminIncome
        id={MINER_SETTINGS_E.ADMIN_PERCENT}
        hasCleanUp
        name={formatMessage({ id: "machines.settings.admin_income" })}
        defaultValue={(mining_persent as number) || undefined}
        oldValue={(mining_persent as number) || undefined}
        admin_setting={admin_setting as string | undefined}
        getValue={(value) => {
          setSelectedValue?.(value);
        }}
        onChange={(value, pool) => {
          onSubmit({
            [MINER_SETTINGS_E.ADMIN_PERCENT]: value,
            [MINER_SETTINGS_E.ADMIN_SETTING]: `${pool}` || "-1",
          });
        }}
      />
      <ContractPlanSelect
        id={`contract_plan_${minerId}`}
        contractId={contract}
        planId={miner_plan?.id}
        onChange={onContractPlanChanged}
      />
    </>
  );
}
